import {
  ConsoleAdapter,
  getRequestContext,
  initLogger,
  LogLevel,
  MultiAdapter,
  type LoggerAdapter,
  type Environment,
  isEnvironment,
} from "@ir/core/logger/decorator";
import { SentryLogger } from "@src/infrastructure/services/logger/sentry.logger.processor";
import { AppConfig } from "@src/config/AppConfig";

export class LoggerFactory {
  private static _instance: LoggerFactory;

  public static getInstance(): LoggerFactory {
    if (!LoggerFactory._instance) {
      LoggerFactory._instance = new LoggerFactory();
    }
    return LoggerFactory._instance;
  }

  private constructor() {
    if (!isEnvironment(AppConfig.getEnvironment())) return;

    const currentLogger = AppConfig.getCurrentLogger();
    const dsn = AppConfig.getSentryDsn();
    const environment = AppConfig.getEnvironment();

    const adapters: LoggerAdapter[] = [new ConsoleAdapter()];

    if (currentLogger === "SENTRY") {
      adapters.push(
        new SentryLogger({
          dsn,
          environment: environment as Environment,
          replaysSessionSampleRate: environment === "production" ? 0.1 : 1,
          replaysOnErrorSampleRate: environment === "production" ? 0.1 : 1,
        }),
      );
    }

    initLogger(
      {
        service_name: "DM-ADMIN-WEBAPP",
        environment: environment as Environment,
        min_level: AppConfig.getLogLevel() as LogLevel,
        hide_meta: true,
        global_meta: {
          version: AppConfig.getAppVersion(),
        },
        context_provider: getRequestContext,
      },
      new MultiAdapter(adapters),
    );
  }
}
